module.exports = __webpack_public_path__ + "img/genoa-verona.338a126b.jpg";